"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _equals = _interopRequireDefault(require("lodash/fp/equals"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _i18n = require("@active/react-utils/i18n");
var _Form = require("../Form");
var _FormGroup = require("../FormGroup");
var _excluded = ["inputId", "labelId", "className", "children", "htmlFor", "htmlForm", "alignment", "verticalStart", "withoutLayout", "truncate", "required", "labelText", "setLabelText"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isHorizontal = (0, _equals["default"])(_Form.HORIZONTAL);
var FormLabel = function FormLabel(_ref, ref) {
  var inputId = _ref.inputId,
    labelId = _ref.labelId,
    className = _ref.className,
    children = _ref.children,
    htmlFor = _ref.htmlFor,
    htmlForm = _ref.htmlForm,
    alignment = _ref.alignment,
    verticalStart = _ref.verticalStart,
    withoutLayout = _ref.withoutLayout,
    truncate = _ref.truncate,
    required = _ref.required,
    labelText = _ref.labelText,
    setLabelText = _ref.setLabelText,
    htmlAttr = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var textElementRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    overflow = _useState2[0],
    setOverflow = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    title = _useState4[0],
    setTitle = _useState4[1];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var updateOverflow = (0, _react.useCallback)((0, _debounce["default"])(function () {
    var _textElementRef$curre, _textElementRef$curre2;
    setOverflow(!!textElementRef.current && ((_textElementRef$curre = textElementRef.current) === null || _textElementRef$curre === void 0 ? void 0 : _textElementRef$curre.scrollWidth) > ((_textElementRef$curre2 = textElementRef.current) === null || _textElementRef$curre2 === void 0 ? void 0 : _textElementRef$curre2.clientWidth));
  }, 50), [setOverflow]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var updateTitle = (0, _react.useCallback)((0, _debounce["default"])(function () {
    var _textElementRef$curre3;
    setTitle((_textElementRef$curre3 = textElementRef.current) === null || _textElementRef$curre3 === void 0 ? void 0 : _textElementRef$curre3.innerText);
  }, 50), [setTitle]);
  (0, _react.useEffect)(function () {
    var resizeObserver;
    var observer;
    var textEle = textElementRef.current;
    if (truncate) {
      resizeObserver = new ResizeObserver(updateOverflow);
      resizeObserver.observe(textEle);
      updateTitle();
      var observerOptions = {
        subtree: true,
        characterData: true
      };
      observer = new MutationObserver(function () {
        updateOverflow();
        updateTitle();
      });
      observer.observe(textEle, observerOptions);
    }
    return function () {
      var _resizeObserver, _observer;
      (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 || _resizeObserver.unobserve(textEle);
      (_observer = observer) === null || _observer === void 0 || _observer.disconnect();
    };
  }, [truncate, updateOverflow, updateTitle, textElementRef]);
  (0, _react.useLayoutEffect)(function () {
    var _textElementRef$curre4;
    if (textElementRef.current && labelText !== ((_textElementRef$curre4 = textElementRef.current) === null || _textElementRef$curre4 === void 0 ? void 0 : _textElementRef$curre4.textContent)) {
      var _textElementRef$curre5, _textElementRef$curre6;
      setLabelText === null || setLabelText === void 0 || setLabelText((_textElementRef$curre5 = (_textElementRef$curre6 = textElementRef.current) === null || _textElementRef$curre6 === void 0 ? void 0 : _textElementRef$curre6.textContent) !== null && _textElementRef$curre5 !== void 0 ? _textElementRef$curre5 : '');
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "form-label",
    ref: ref,
    className: (0, _classnames["default"])({
      'grid-item span-sm-12 span-md-3 offset-md-1': isHorizontal(alignment) && !withoutLayout
    }, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('form-label', {
      'form-label-vertical-start': verticalStart,
      'form-label-truncate': truncate
    })
  }, /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({
    ref: textElementRef,
    id: labelId,
    htmlFor: htmlFor || inputId,
    form: htmlForm
  }, overflow ? {
    title: title
  } : {}, (0, _omit["default"])(['name', 'errorId'])(htmlAttr)), typeof children === 'string' ? /*#__PURE__*/_react["default"].createElement(_i18n.Locale, {
    id: children
  }) : children), required && /*#__PURE__*/_react["default"].createElement("span", {
    className: "form-label-asterisk",
    "aria-hidden": "true"
  }, "*")));
};
var FormLabelContainer = (0, _compose["default"])((0, _curryRight["default"])(_Form.connectForm)(function (_ref2) {
  var customizeLayout = _ref2.customizeLayout,
    alignment = _ref2.form.alignment;
  return _objectSpread({
    alignment: alignment
  }, customizeLayout ? {
    withoutLayout: true
  } : {});
}), _FormGroup.connectFormGroup, _react.memo, _react["default"].forwardRef)(FormLabel);
var _default = exports["default"] = FormLabelContainer;